module.exports = __webpack_public_path__ + "img/al.0462e5b1.svg";